@if (open) {
  <div class="modal-backdrop" (click)="cancel()">
    <div #dialog class="modal-container" role="dialog" aria-modal="true" aria-labelledby="dup-modal-title" tabindex="-1"
         (click)="onModalClick($event)" (keydown.escape)="cancel()">
      <div class="modal-header">
        <div class="header-icon">
          <i class="material-symbols-rounded" aria-hidden="true">content_copy</i>
        </div>
        <div class="header-content">
          <h2 id="dup-modal-title">{{ title() }}</h2>
          <p>{{ subtitle() }}</p>
        </div>
        <button class="close-btn" (click)="cancel()" title="Close" aria-label="Close">
          <i class="material-symbols-rounded" aria-hidden="true">close</i>
        </button>
      </div>

      <div class="modal-body">
        @for (card of cards(); track card.billGroupId) {
          <div class="duplicate-card" [class.replacing]="card.selected === 'REPLACE'">
            <div class="card-heading">
              <i class="material-symbols-rounded" aria-hidden="true">speed</i>
              <span>{{ card.heading }}</span>
            </div>

            <div class="compare">
              <!-- This upload -->
              <div class="bill-column">
                <div class="column-label">This upload</div>
                <div class="bill-dates">{{ card.uploadDates }}</div>
                <div class="bill-totals">{{ card.uploadTotals }}</div>
                <span class="sides-chip">{{ card.uploadSides }}</span>
              </div>

              <!-- Same dates marker -->
              <div class="match-marker">
                <i class="material-symbols-rounded" aria-hidden="true">equal</i>
                <span>{{ card.markerLabel }}</span>
              </div>

              <!-- Already imported -->
              <div class="bill-column existing">
                <div class="column-label">{{ card.existingLabel }}</div>
                @if (card.existingBillLine) {
                  <div class="bill-ref">{{ card.existingBillLine }}</div>
                }
                <div class="bill-dates">{{ card.existingDates }}</div>
                <div class="bill-totals">{{ card.existingTotals }}</div>
                <div class="chip-row">
                  <span class="sides-chip">{{ card.existingSides }}</span>
                  @if (card.importedOn) {
                    <span class="imported-on">{{ card.importedOn }}</span>
                  }
                </div>
                <div class="pdf-links">
                  @for (link of card.pdfLinks; track link.type) {
                    <button type="button" class="pdf-link" (click)="openPdf(card, link.type)">
                      <i class="material-symbols-rounded" aria-hidden="true">picture_as_pdf</i>
                      {{ link.label }}
                    </button>
                  } @empty {
                    <span class="no-pdf">No PDF on file</span>
                  }
                </div>
              </div>
            </div>

            <!-- Choice -->
            <div class="choice-row">
              <div class="segments" role="radiogroup" aria-label="What to do with this bill">
                <button type="button" role="radio" class="segment skip"
                        [class.selected]="card.selected === 'SKIP'"
                        [attr.aria-checked]="card.selected === 'SKIP'"
                        (click)="selectAction(card, 'SKIP')">
                  <i class="material-symbols-rounded" aria-hidden="true">skip_next</i>
                  {{ card.skipLabel }}
                </button>
                @if (card.replaceable) {
                  <button type="button" role="radio" class="segment replace"
                          [class.selected]="card.selected === 'REPLACE'"
                          [attr.aria-checked]="card.selected === 'REPLACE'"
                          (click)="selectAction(card, 'REPLACE')">
                    <i class="material-symbols-rounded" aria-hidden="true">swap_horiz</i>
                    {{ card.replaceLabel }}
                  </button>
                }
              </div>

              @if (card.selected === 'REPLACE') {
                <div class="replace-warning" role="alert">
                  <i class="material-symbols-rounded" aria-hidden="true">warning</i>
                  <span>{{ card.replaceWarning }}</span>
                </div>
              } @else if (!card.replaceable && card.blockedMessage) {
                <div class="blocked-note">
                  <i class="material-symbols-rounded" aria-hidden="true">lock</i>
                  <span>{{ card.blockedMessage }}</span>
                </div>
              }
            </div>
          </div>
        }

        @if (cards().length === 0) {
          <div class="empty-state">
            <i class="material-symbols-rounded" aria-hidden="true">check_circle</i>
            <p>No bills here are already imported.</p>
          </div>
        }
      </div>

      <div class="modal-footer">
        <div class="footer-info">{{ summary() }}</div>
        <div class="footer-actions">
          <button class="btn-secondary" (click)="cancel()">Back</button>
          <button class="btn-primary" (click)="confirm()">
            Continue
            <i class="material-symbols-rounded" aria-hidden="true">arrow_forward</i>
          </button>
        </div>
      </div>
    </div>
  </div>
}
